import UniqueId from 'vue-unique-id';
import Vue from 'vue';

import axios from './axios';
import clickOutside from './click-outside';
import datepicker from './datepicker';
import dialog from './dialog';
import eventhub from './eventhub';
import notifcations from './notifications';
import portal from './portal';
import routes from './routes';
import submitOnce from './submit-once';
import tooltip from './tooltip';
import touchEvents from './touch-events';

export default {
    init() {
        axios.init();
        clickOutside.init();
        datepicker.init();
        dialog.init();
        eventhub.init();
        notifcations.init();
        portal.init();
        routes.init();
        submitOnce.init();
        tooltip.init();
        touchEvents.init();

        Vue.use(UniqueId);
    },
};
